module.exports = __webpack_public_path__ + "img/1483727595.a9c0cfd9.jpg";